import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fed28ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-font-size mb--20" }, "Поделиться", -1))
const _hoisted_2 = { class: "share-btns" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xs-font-size dark-text-color" }, "Вконтакте", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xs-font-size dark-text-color" }, " Одноклассники ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xs-font-size dark-text-color" }, " Скопировать ссылку ", -1))

import { computed, ref } from 'vue';
import { useShare } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareBtn',
  props: {
    width: { default: '36' },
    height: { default: '36' },
    fontSize: {},
    color: { default: '#614B40FF' },
    btnType: { default: 'border' },
    link: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const link = computed(() => {
  return props.link ? props.link : window.location.href;
});

const vkLink = computed(() => {
  return `https://vk.com/share.php?url=${link.value}`;
});

const okLink = computed(() => {
  return `https://connect.ok.ru/offer?url=${link.value}`;
});
const shareHandler = (link: string, target: string) => {
  window.open(
    link,
    target,
    'width=860, height=470, top=' +
      (screen.height - 470) / 2 +
      ',left=' +
      (screen.width - 860) / 2 +
      '',
  );

  return false;
};

const copyLink = () => {
  navigator.clipboard.writeText(link.value);
};

const options = ref({
  title: 'МОЙИЖС',
  text: 'Платформа МОЙИЖС, посмотреть ссылку: ',
  url: link.value,
});

const { share, isSupported } = useShare(options);
const startShare = () => {
  if (isSupported.value) {
    return share().catch(err => err);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_popup = _resolveComponent("base-popup")!

  return (_openBlock(), _createBlock(_component_base_popup, {
    disabled: _unref(isSupported),
    "with-padding": ""
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "items-in-column align-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (shareHandler(vkLink.value, 'Vkontakte')))
          }, [
            _createVNode(_component_base_image, {
              src: require('@/assets/img/socials/vk.png'),
              contain: "",
              height: "50",
              name: "vk"
            }, null, 8, ["src"]),
            _hoisted_3
          ]),
          _createElementVNode("button", {
            class: "items-in-column align-center",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (shareHandler(okLink.value, 'Ok')))
          }, [
            _createVNode(_component_base_image, {
              src: require('@/assets/img/socials/ok.png'),
              contain: "",
              height: "50",
              name: "ok"
            }, null, 8, ["src"]),
            _hoisted_4
          ]),
          _createElementVNode("button", {
            class: "items-in-column align-center",
            onClick: copyLink
          }, [
            _createVNode(_component_base_image, {
              src: require('@/assets/img/socials/link.png'),
              contain: "",
              height: "50",
              name: "link"
            }, null, 8, ["src"]),
            _hoisted_5
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_base_button, {
        class: _normalizeClass({ scale: !_ctx.disabled }),
        disabled: _ctx.disabled,
        height: _ctx.height,
        "style-type": _ctx.btnType,
        width: _ctx.width,
        icon: "",
        "without-active": "",
        onClick: startShare
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_base_icon, {
            color: _ctx.color,
            "font-size": _ctx.fontSize,
            height: String(+_ctx.height - 12),
            width: String(+_ctx.width - 12),
            contain: "",
            name: "share"
          }, null, 8, ["color", "font-size", "height", "width"])
        ]),
        _: 1
      }, 8, ["class", "disabled", "height", "style-type", "width"])
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})